// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3HjhZ","header":"PatientQuestionnaire_header__UUWXR","info":"PatientQuestionnaire_info__1cmWA"};